<div class="modal">
    <div class="modal-content">
        <h1>Message: </h1>
        <span class="close" (click)="modalCloseClicked()">&times;</span>

        <p>{{message}}</p>
    </div>
</div>